import { Box } from '@mui/material';
import { Alert } from '../../../components/Alert';
import { useAlert } from '../../../context';

export function LoginAlert() {
  const { alerts, onClose } = useAlert();

  if (alerts.length === 0) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: '80%',
        left: '50%',
        transform: 'translateX(-50%)',
        minWidth: '800px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        zIndex: 1300,
      }}
    >
      {alerts.map((alert) => (
        <Alert
          key={alert.id}
          variant={alert.variant}
          message={alert.message}
          open
          onClose={() => onClose(alert.id)}
        />
      ))}
    </Box>
  );
}
